import { AxiosResponse } from 'axios';
import cmsAPI from './knoxverse';
import { CMSLink } from '../../../myknox/scripts/types/CMSLink';

const fetchTopSearchTerms = async (): Promise<CMSLink[]> => {
    const res: AxiosResponse<CMSLink[]> = await cmsAPI.get(`/knoxapi/gettopsearchterms`);
    return res.data;
};

export default fetchTopSearchTerms;